import { api } from './api'
import { FinancialRecurringTransaction } from '../Interfaces/financialRecurring'

export type CreateRecurringTransactionPayload = {
  type: string
  category: string
  document_number?: string | null
  movement_date: string
  due_date?: string | null
  value: number
  recurrence?: number
  client_id: number
  payment_method_id?: number
  payment_condition_id?: number
  observation?: string | null
  is_recurring?: boolean
}

export type UpdateRecurringTransactionPayload = Partial<{
  type: string
  category: string
  document_number: string
  movement_date: string
  due_date: string
  payment_date: string | null
  value: number
  status: string
  interest_value: number
  paid_value: number
  client_id: number
  payment_method_id: number | null
  observation: string | null
  is_recurring: boolean
  recurrence: number
}>

export type MarkRecurringTransactionAsPaidPayload = {
  payment_date: string
  interest_value?: number
  paid_value?: number
  payment_method_id?: number | null
  payment_condition_id?: number | null
}

export async function createFinancialTransaction(payload: CreateRecurringTransactionPayload) {
  const { data } = await api.post<{ data: FinancialRecurringTransaction[] }>('financial/transactions', payload)

  return data
}

export async function updateFinancialTransaction(id: number, payload: UpdateRecurringTransactionPayload) {
  const { data } = await api.put<FinancialRecurringTransaction>('financial/transactions/' + id, payload)

  return data
}

export async function deleteFinancialTransaction(id: number, options?: { scope?: 'single' | 'group' | 'end' }) {
  await api.delete('financial/transactions/' + id, {
    params: {
      scope: options?.scope ?? 'single',
    },
  })
}

export async function markFinancialTransactionAsPaid(id: number, payload: MarkRecurringTransactionAsPaidPayload) {
  const { data } = await api.post<FinancialRecurringTransaction>('financial/transactions/' + id + '/pay', payload)

  return data
}

export const createRecurringTransaction = createFinancialTransaction
export const updateRecurringTransaction = updateFinancialTransaction
export const deleteRecurringTransaction = deleteFinancialTransaction
export const markRecurringTransactionAsPaid = markFinancialTransactionAsPaid
